// removed by extract-text-webpack-plugin
module.exports = {"container":"_3oH0r","image":"_2hO_9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.scss
// module id = ./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.scss
// module chunks = 4